import { useMemo } from 'react'

import { Dropdown, Flex, Typography } from 'antd'
import { createStyles } from 'antd-style'

import { getFirstScrolledParent } from '@eastcoal/common/utils/dom'

import { useFontSize } from '../../hooks/useFontSize'
import { SHORTCUTS } from '../../plugins/ShortcutsPlugin/shortcuts'
import { DropdownButton } from '../../ui/DropdownButton'

const useStyles = createStyles(({ token }) => ({
  menu: {
    width: 160,
    maxHeight: 340,
    overflowY: 'auto',
    scrollBehavior: 'smooth'
  }
}))

export const FontSizeDropdown = () => {
  const { fontSize, setFontSize, fontSizeList } = useFontSize()

  const items = useMemo(
    () =>
      fontSizeList.map(({ label, value }) => ({
        key: label,
        label: (
          <Flex align='center' gap={0} justify='center'>
            <span>{label}</span>
            <Typography.Text type='secondary'>（{value}）</Typography.Text>
          </Flex>
        )
      })),
    [fontSizeList]
  )
  const { selectedItem, selectedKeys } = useMemo(() => {
    const selectedItem = fontSizeList.find(item => item.value === fontSize)
    return {
      selectedItem,
      selectedKeys: selectedItem ? [selectedItem.label] : undefined
    }
  }, [fontSizeList, fontSize])

  const { styles } = useStyles()

  return (
    <Dropdown
      getPopupContainer={triggerNode => getFirstScrolledParent(triggerNode)}
      trigger={['click']}
      menu={{
        items,
        selectedKeys,
        className: styles.menu,
        onClick({ key }) {
          const selectedItem = fontSizeList.find(item => item.label === key)
          if (selectedItem) {
            setFontSize(selectedItem.value)
          }
        }
      }}
    >
      <DropdownButton
        tooltip={
          <Flex vertical align='center'>
            <span>字体大小</span>
            <span>{SHORTCUTS.FONT_SIZE}</span>
          </Flex>
        }
      >
        <span>{selectedItem?.label ?? fontSize}</span>
      </DropdownButton>
    </Dropdown>
  )
}
